import { useTranslation } from 'react-i18next';

import { CATEGORY_FILTERS, CategoryFilter, SORT_OPTIONS, SortOption } from '@codes/marketplace/marketplace';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@codes/ui-kit/components/ui/select';

interface MarketplaceFiltersProps {
    category: CategoryFilter;
    sortBy: SortOption;
    totalCount: number;
    onCategoryChange: (category: CategoryFilter) => void;
    onSortChange: (sortBy: SortOption) => void;
}

export const MarketplaceFilters = ({
    category,
    sortBy,
    totalCount,
    onCategoryChange,
    onSortChange,
}: MarketplaceFiltersProps) => {
    const { t } = useTranslation();

    return (
        <div className="flex items-center gap-4 mb-10">
            {/* Sort Filter */}
            <Select value={sortBy} onValueChange={value => onSortChange(value as SortOption)}>
                <SelectTrigger className="w-[180px]">
                    <SelectValue placeholder={t('marketplace.filter.sort')} />
                </SelectTrigger>
                <SelectContent>
                    {SORT_OPTIONS.map(option => (
                        <SelectItem key={option} value={option}>
                            {t(`marketplace.sort.${option}`)}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>

            {/* Category Filter */}
            <Select value={category} onValueChange={value => onCategoryChange(value as CategoryFilter)}>
                <SelectTrigger className="w-[180px]">
                    <SelectValue placeholder={t('marketplace.filter.category')} />
                </SelectTrigger>
                <SelectContent>
                    {CATEGORY_FILTERS.map(cat => (
                        <SelectItem key={cat} value={cat}>
                            {t(`marketplace.category.${cat}`)}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>

            <div className="text-text-400">|</div>
            <div className="text-point text-sm font-medium">Total {totalCount}</div>
        </div>
    );
};
